import { useAppDispatch, useAppSelector } from '../../appStore';
import { SurveyThemeValueChangeEvent } from '../../components/pages/branding-and-theme/SurveyThemeSection';
import Constants from '../../constants';
import { ProgressMeterType, SurveyLogoPlacement } from '../../models';
import { removeSurveyImage, updateDisplayName, updateFile, updatePlacement } from '../../store/SurveyImageSlice';
import { ActionCreators as SurveyActionCreators } from '../../store/SurveyStore';
import { setSurveyTheme, updateSurveyThemeValue } from '../../store/SurveyThemeSlice';

export const useBrandingAndTheme = () => {
	const dispatch = useAppDispatch();

	const { surveyEditModel } = useAppSelector((state) => state.survey);

	const { surveyImage, file: surveyLogoFile, validationResult: surveyImageValidationResult } = useAppSelector((state) => state.surveyImage);

	const { themes } = useAppSelector((state) => state.themes);

	const { surveyTheme, validationResult: surveyThemeValidationResult } = useAppSelector((state) => state.surveyTheme);

	const handleSurveyLogoDisplayNameChange = (displayName: string) => dispatch(updateDisplayName(displayName));

	const handleSurveyLogoPlacementChange = (placement: SurveyLogoPlacement) => dispatch(updatePlacement(placement));

	const handleSurveyLogoFileChange = (file: File) => dispatch(updateFile(file));

	const handleRemoveSurveyLogo = () => dispatch(removeSurveyImage());

	const handleShowKincentricLogoChange = (value: boolean) => dispatch(SurveyActionCreators.HandleShowKincentricLogoChange(value));

	const handleThemeChange = (themeName: string) => dispatch(setSurveyTheme({ name: themeName, theme: themes[themeName] }));

	const handleSurveyThemeValueChange = (event: SurveyThemeValueChangeEvent) => {
		if (!surveyTheme) {
			dispatch(
				setSurveyTheme({
					name: Constants.CUSTOM_THEME_NAME,
					theme: { ...themes[Constants.DEFAULT_THEME_NAME], [event.target.name]: event.target.value },
				}),
			);
			return;
		}

		dispatch(updateSurveyThemeValue({ name: event.target.name, value: event.target.value }));
	};

	const handleSurveyProgressMeterTypeChange = (selectedValue: ProgressMeterType) =>
		dispatch(SurveyActionCreators.HandleSurveyProgressMeterTypeChange(selectedValue));

	const handleShowQuestionNumberingChange = (selectedValue: boolean) =>
		dispatch(SurveyActionCreators.HandleShowQuestionNumberingChange(selectedValue));

	const {
		survey: { showKincentricLogo },
		progressMeterType,
		shouldShowQuestionNumbering,
	} = surveyEditModel;

	return {
		surveyImage,
		surveyImageValidationResult,
		surveyLogoFile,
		showKincentricLogo,
		themes,
		surveyTheme,
		surveyThemeValidationResult,
		progressMeterType,
		shouldShowQuestionNumbering,
		handleSurveyLogoDisplayNameChange,
		handleSurveyLogoPlacementChange,
		handleSurveyLogoFileChange,
		handleRemoveSurveyLogo,
		handleShowKincentricLogoChange,
		handleThemeChange,
		handleSurveyThemeValueChange,
		handleSurveyProgressMeterTypeChange,
		handleShowQuestionNumberingChange,
	};
};
